import {
  Time as TimeIcon,
  CheckCirclIcon,
} from "../svgs";
import { StyledText } from "./basic";


const OrderStatusCard = ({ location, stage, arrivalDate }) => {
  return (
    <>
      <div style={{ paddingLeft: '7px', boxSizing: 'border-box' }}>
        <OrderStatusStage isCompleted={stage === 'ready' || stage === 'in-progress'}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Voucher Enroute to
            <span style={{ color: '#E31C79' }}> {location}</span>
          </StyledText>
          {/* {
            (stage === 'ready' || stage === 'in-progress') &&
            <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>} */}
        </OrderStatusStage>

        <OrderStatusStage isCompleted={stage === 'ready'} isLast={true}>
          <StyledText size={12} style={{ margin: '0 0 5px 0', fontFamily: 'MTNRegular' }}>
            Voucher Ready for Pickup {arrivalDate ? `(${arrivalDate})` : ''}
          </StyledText>
          {/* {
            stage === 'ready' &&
            <StyledText size={10} color="#828282" style={{ margin: 0, fontFamily: 'MTNRegular' }}>28/07/2022  09:54</StyledText>
          } */}
        </OrderStatusStage>
      </div>
      <div style={{
        display: 'flex',
        background: stage !== 'ready' ? '#FFCD00' : '#0FAF4B',
        color: stage !== 'ready' ? '#000' : '#fff',
        padding: '20px',
        borderRadius: '10px',
        justifyContent: 'space-around'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {stage !== 'ready' ? <TimeIcon width={28} /> : <CheckCirclIcon color="#0FAF4B" fill="white" width={28} />}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '0 5px', width: '80%' }}>
          <div>
            <StyledText size={18} style={{ margin: '0 0 3px 0' }}>Order {stage !== 'ready' ? 'Pending' : 'Ready'}</StyledText>
            <StyledText size={10} style={{ margin: '0', fontFamily: 'MTNRegular' }}>
              {
                stage !== 'ready' ?
                  'You will be notified when your order is ready' : 'Visit selected MTN Office to pickup reward'
              }
            </StyledText>
          </div>
        </div>
      </div>
    </>
  )
}

const OrderStatusStage = ({ children, isCompleted, isLast }) => {
  return (
    <div style={{
      borderLeft: `2px solid ${isLast ? '#fff' : '#BDBDBD'}`,
      padding: '0 0 30px 20px',
      boxSizing: 'border-box',
      position: 'relative'
    }}
    >
      <div style={{
        background: '#BDBDBD',
        boxSizing: 'border-box',
        position: "absolute",
        height: '16px', width: '16px',
        borderRadius: '20px',
        top: 0,
        left: '-9px'
      }}>
        {isCompleted && <CheckCirclIcon width={16} fill={'#0FAF4B'} />}
      </div>
      {children}
    </div>
  )
};

export default OrderStatusCard;
